import Phaser from 'phaser';
import { CANVAS_WIDTH, CANVAS_HEIGHT, LEFT_PANEL_WIDTH, TOP_PANEL_HEIGHT, MAZE_WIDTH, MAZE_HEIGHT } from '../utils/constants';

export class MenuScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MenuScene' });
  }

  create(): void {
    // Launch GameScene in demo mode behind us
    this.scene.launch('GameScene', { demo: true });
    this.scene.bringToTop('MenuScene');

    // Semi-transparent backdrop over the maze area
    const cx = LEFT_PANEL_WIDTH + MAZE_WIDTH / 2;
    const cy = TOP_PANEL_HEIGHT + MAZE_HEIGHT / 2;

    const backdrop = this.add.rectangle(
      CANVAS_WIDTH / 2, CANVAS_HEIGHT / 2,
      CANVAS_WIDTH, CANVAS_HEIGHT,
      0x000000, 0.55,
    );

    // Title
    this.add.text(cx, cy - 100, 'LABYRINTH', {
      fontSize: '52px',
      color: '#ffffff',
      fontStyle: 'bold',
    }).setOrigin(0.5);

    // Controls — rendered as individual text segments for per-word coloring
    const lineH = 28;
    const baseStyle = { fontSize: '16px', color: '#cccccc' };
    const greenStyle = { fontSize: '16px', color: '#44ff44' };
    const redStyle = { fontSize: '16px', color: '#ff4444' };

    // Line 1: WASD / Arrow Keys  —  Move
    this.add.text(cx, cy - lineH, 'WASD / Arrow Keys  —  Move', baseStyle).setOrigin(0.5);

    // Line 2: Mouse Click  —  Build / Remove  Walls
    const line2Y = cy;
    const line2Parts = [
      { text: 'Mouse Click  —  ', style: baseStyle },
      { text: 'Build', style: greenStyle },
      { text: ' / ', style: baseStyle },
      { text: 'Remove', style: redStyle },
      { text: ' Walls', style: baseStyle },
    ];
    this.renderColoredLine(cx, line2Y, line2Parts);

    // Line 3: Reach the Exit  —  Don't Die
    this.add.text(cx, cy + lineH, 'Reach the Exit  —  Don\'t Die', baseStyle).setOrigin(0.5);

    // Line 4: Enemy Builds / Removes Walls
    const line4Y = cy + lineH * 2;
    const line4Parts = [
      { text: 'Enemy ', style: baseStyle },
      { text: 'Builds', style: greenStyle },
      { text: ' / ', style: baseStyle },
      { text: 'Removes', style: redStyle },
      { text: ' Walls', style: baseStyle },
    ];
    this.renderColoredLine(cx, line4Y, line4Parts);

    // Start prompt
    const startText = this.add.text(cx, cy + 120, 'Press any key or click to play', {
      fontSize: '20px',
      color: '#00ff88',
    }).setOrigin(0.5);

    // Pulse the start text
    this.tweens.add({
      targets: startText,
      alpha: { from: 1, to: 0.3 },
      duration: 800,
      yoyo: true,
      repeat: -1,
    });

    // Start game on any input
    const startGame = () => {
      this.scene.stop('GameScene');
      this.scene.stop('UIScene');
      this.scene.start('GameScene', { demo: false });
    };

    this.input.keyboard?.on('keydown', startGame);
    this.input.on('pointerdown', startGame);
  }

  private renderColoredLine(
    cx: number, y: number,
    parts: { text: string; style: Phaser.Types.GameObjects.Text.TextStyle }[],
  ): void {
    // Measure total width to center the line
    const measured = parts.map(p => {
      const t = this.add.text(0, -9999, p.text, p.style);
      const w = t.width;
      t.destroy();
      return w;
    });
    const totalW = measured.reduce((s, w) => s + w, 0);
    let x = cx - totalW / 2;
    for (let i = 0; i < parts.length; i++) {
      this.add.text(x, y, parts[i].text, parts[i].style).setOrigin(0, 0.5);
      x += measured[i];
    }
  }
}
